'use strict';

angular.module('atex.dam').directive('render', [ 'timer', '$rootScope', function(timer, $rootScope) {
  return {
    link : function(scope, elem, attrs, ctrl) {
      var render = function() {
        if (scope.$last === true) {
          $rootScope.$broadcast("dam:render");
        }
      };
      timer(render, 0);
    }
  };
} ]);